import React from 'react'
import { Looks3 } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

import preferredNetworks from '../preferredNetworks'
import NetworksList from '../v2-customer-components/NetworksList'

export default function NetworkCard() {
  return (
    <>
      <Box
        sx={{
          width: '80px',
          height: '80px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: circlesOrbitColorPalette.neutrals[500],
          position: 'absolute',
          ml: '9rem',
          borderRadius: '50%',
          mt: '-70px'
        }}
      >
        <Looks3 sx={{ color: 'white', fontSize: '40px' }} />
      </Box>
      <NormalText
        isBold
        textAlign={'left'}
        sx={{
          fontSize: '24px',
          fontWeight: '700px',
          m: 0
        }}
        text={'Network'}
      />
      <TextColorFontBody
        sx={{
          fontSize: '14px',
          lineHeight: 1,
          color: '#7B8794',
          textAlign: 'left',
          mt: '8px'
        }}
      >
        Check that customer is connected to a network that&apos;s available in
        the country they&apos;re in
      </TextColorFontBody>

      <Stack
        flexDirection={'row'}
        sx={{ mt: '30px', mb: '8px', justifyContent: 'space-between' }}
      >
        <NetworksList preferredNetworks={preferredNetworks}>
          <NormalText variant='h1'>
            {' '}
            Click{' '}
            <span
              style={{
                cursor: 'pointer',
                fontWeight: '700',
                textDecoration: 'underline',
                color: '#0000FF'
              }}
            >
              here
            </span>{' '}
            to view the available networks and the countries
          </NormalText>
        </NetworksList>
      </Stack>
    </>
  )
}
